import AreaOrderingDialog from './areaOrderingDialog'
export default AreaOrderingDialog
